// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/artifactstudio/v1/artifact_studio.proto (package mono.artifactstudio.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * ArtifactTypeInfo is one option in the "new artifact" picker.
 *
 * @generated from message mono.artifactstudio.v1.ArtifactTypeInfo
 */ export class ArtifactTypeInfo extends Message {
    static fromBinary(bytes, options) {
        return new ArtifactTypeInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ArtifactTypeInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ArtifactTypeInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ArtifactTypeInfo, a, b);
    }
    constructor(data){
        super(), /**
   * e.g. "compliance_matrix"
   *
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * e.g. "Compliance Matrix"
   *
   * @generated from field: string display_name = 2;
   */ _define_property(this, "displayName", ""), /**
   * docx|pptx|xlsx
   *
   * @generated from field: string file_type = 3;
   */ _define_property(this, "fileType", ""), /**
   * Phase 3b-3: this type always requires attorney review before approval
   * (e.g. protest_decision_packet). The picker badges it.
   *
   * @generated from field: bool legal_review_required = 4;
   */ _define_property(this, "legalReviewRequired", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ArtifactTypeInfo, "runtime", proto3);
_define_property(ArtifactTypeInfo, "typeName", "mono.artifactstudio.v1.ArtifactTypeInfo");
_define_property(ArtifactTypeInfo, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "display_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "file_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "legal_review_required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.ListArtifactTypesRequest
 */ export class ListArtifactTypesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListArtifactTypesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListArtifactTypesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListArtifactTypesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListArtifactTypesRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListArtifactTypesRequest, "runtime", proto3);
_define_property(ListArtifactTypesRequest, "typeName", "mono.artifactstudio.v1.ListArtifactTypesRequest");
_define_property(ListArtifactTypesRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.artifactstudio.v1.ListArtifactTypesResponse
 */ export class ListArtifactTypesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListArtifactTypesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListArtifactTypesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListArtifactTypesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListArtifactTypesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.artifactstudio.v1.ArtifactTypeInfo types = 1;
   */ _define_property(this, "types", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListArtifactTypesResponse, "runtime", proto3);
_define_property(ListArtifactTypesResponse, "typeName", "mono.artifactstudio.v1.ListArtifactTypesResponse");
_define_property(ListArtifactTypesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "types",
            kind: "message",
            T: ArtifactTypeInfo,
            repeated: true
        }
    ]));
/**
 * StudioAsset is the user-facing view of a generated artifact. artifact_type is
 * resolved from the asset's template; document_id is set once an editor session
 * has been opened on the seed.
 *
 * @generated from message mono.artifactstudio.v1.StudioAsset
 */ export class StudioAsset extends Message {
    static fromBinary(bytes, options) {
        return new StudioAsset().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StudioAsset().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StudioAsset().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StudioAsset, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string project_id = 2;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string title = 3;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string artifact_type = 4;
   */ _define_property(this, "artifactType", ""), /**
   * @generated from field: string file_type = 5;
   */ _define_property(this, "fileType", ""), /**
   * ai_drafted|in_review|approved|rejected
   *
   * @generated from field: string approval_state = 6;
   */ _define_property(this, "approvalState", ""), /**
   * generator|copilot
   *
   * @generated from field: string generated_by = 7;
   */ _define_property(this, "generatedBy", ""), /**
   * shirohige CollaborativeDocument id (may be empty)
   *
   * @generated from field: string document_id = 8;
   */ _define_property(this, "documentId", ""), /**
   * @generated from field: string approved_by_user_id = 9;
   */ _define_property(this, "approvedByUserId", ""), /**
   * @generated from field: google.protobuf.Timestamp approved_at = 10;
   */ _define_property(this, "approvedAt", void 0), /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * Phase 3b-3: the asset's type mandates attorney review (intrinsic to the
   * artifact type, stamped server-side). The UI badges it and gates the
   * approve action accordingly.
   *
   * @generated from field: bool legal_review_required = 12;
   */ _define_property(this, "legalReviewRequired", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(StudioAsset, "runtime", proto3);
_define_property(StudioAsset, "typeName", "mono.artifactstudio.v1.StudioAsset");
_define_property(StudioAsset, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "artifact_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "file_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "approval_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "generated_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "approved_by_user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "approved_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "legal_review_required",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.GenerateFirstDraftRequest
 */ export class GenerateFirstDraftRequest extends Message {
    static fromBinary(bytes, options) {
        return new GenerateFirstDraftRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateFirstDraftRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateFirstDraftRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateFirstDraftRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string artifact_type = 2;
   */ _define_property(this, "artifactType", ""), /**
   * Optional display title; defaults to a type-derived title when empty.
   *
   * @generated from field: string title = 3;
   */ _define_property(this, "title", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateFirstDraftRequest, "runtime", proto3);
_define_property(GenerateFirstDraftRequest, "typeName", "mono.artifactstudio.v1.GenerateFirstDraftRequest");
_define_property(GenerateFirstDraftRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.GenerateFirstDraftResponse
 */ export class GenerateFirstDraftResponse extends Message {
    static fromBinary(bytes, options) {
        return new GenerateFirstDraftResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GenerateFirstDraftResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GenerateFirstDraftResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GenerateFirstDraftResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifactstudio.v1.StudioAsset asset = 1;
   */ _define_property(this, "asset", void 0), /**
   * The shirohige CollaborativeDocument id to open in the editor.
   *
   * @generated from field: string document_id = 2;
   */ _define_property(this, "documentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GenerateFirstDraftResponse, "runtime", proto3);
_define_property(GenerateFirstDraftResponse, "typeName", "mono.artifactstudio.v1.GenerateFirstDraftResponse");
_define_property(GenerateFirstDraftResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "asset",
            kind: "message",
            T: StudioAsset
        },
        {
            no: 2,
            name: "document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.ListProjectAssetsRequest
 */ export class ListProjectAssetsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectAssetsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectAssetsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectAssetsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectAssetsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectAssetsRequest, "runtime", proto3);
_define_property(ListProjectAssetsRequest, "typeName", "mono.artifactstudio.v1.ListProjectAssetsRequest");
_define_property(ListProjectAssetsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.ListProjectAssetsResponse
 */ export class ListProjectAssetsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListProjectAssetsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListProjectAssetsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListProjectAssetsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListProjectAssetsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.artifactstudio.v1.StudioAsset assets = 1;
   */ _define_property(this, "assets", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListProjectAssetsResponse, "runtime", proto3);
_define_property(ListProjectAssetsResponse, "typeName", "mono.artifactstudio.v1.ListProjectAssetsResponse");
_define_property(ListProjectAssetsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "assets",
            kind: "message",
            T: StudioAsset,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.GetAssetRequest
 */ export class GetAssetRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetAssetRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAssetRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAssetRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAssetRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAssetRequest, "runtime", proto3);
_define_property(GetAssetRequest, "typeName", "mono.artifactstudio.v1.GetAssetRequest");
_define_property(GetAssetRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.GetAssetResponse
 */ export class GetAssetResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetAssetResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetAssetResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetAssetResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetAssetResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifactstudio.v1.StudioAsset asset = 1;
   */ _define_property(this, "asset", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetAssetResponse, "runtime", proto3);
_define_property(GetAssetResponse, "typeName", "mono.artifactstudio.v1.GetAssetResponse");
_define_property(GetAssetResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "asset",
            kind: "message",
            T: StudioAsset
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.TransitionApprovalRequest
 */ export class TransitionApprovalRequest extends Message {
    static fromBinary(bytes, options) {
        return new TransitionApprovalRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransitionApprovalRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransitionApprovalRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransitionApprovalRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * in_review|approved|rejected
   *
   * @generated from field: string to_state = 2;
   */ _define_property(this, "toState", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TransitionApprovalRequest, "runtime", proto3);
_define_property(TransitionApprovalRequest, "typeName", "mono.artifactstudio.v1.TransitionApprovalRequest");
_define_property(TransitionApprovalRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "to_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.TransitionApprovalResponse
 */ export class TransitionApprovalResponse extends Message {
    static fromBinary(bytes, options) {
        return new TransitionApprovalResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TransitionApprovalResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TransitionApprovalResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TransitionApprovalResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.artifactstudio.v1.StudioAsset asset = 1;
   */ _define_property(this, "asset", void 0), /**
   * @generated from field: string audit_event_id = 2;
   */ _define_property(this, "auditEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(TransitionApprovalResponse, "runtime", proto3);
_define_property(TransitionApprovalResponse, "typeName", "mono.artifactstudio.v1.TransitionApprovalResponse");
_define_property(TransitionApprovalResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "asset",
            kind: "message",
            T: StudioAsset
        },
        {
            no: 2,
            name: "audit_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.SubmissionPackageItem
 */ export class SubmissionPackageItem extends Message {
    static fromBinary(bytes, options) {
        return new SubmissionPackageItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmissionPackageItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmissionPackageItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmissionPackageItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string asset_id = 1;
   */ _define_property(this, "assetId", ""), /**
   * @generated from field: string artifact_type = 2;
   */ _define_property(this, "artifactType", ""), /**
   * @generated from field: string approval_state = 3;
   */ _define_property(this, "approvalState", ""), /**
   * @generated from field: bool included = 4;
   */ _define_property(this, "included", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SubmissionPackageItem, "runtime", proto3);
_define_property(SubmissionPackageItem, "typeName", "mono.artifactstudio.v1.SubmissionPackageItem");
_define_property(SubmissionPackageItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "asset_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "artifact_type",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "approval_state",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "included",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.AssembleSubmissionPackageRequest
 */ export class AssembleSubmissionPackageRequest extends Message {
    static fromBinary(bytes, options) {
        return new AssembleSubmissionPackageRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssembleSubmissionPackageRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssembleSubmissionPackageRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssembleSubmissionPackageRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: repeated string asset_ids = 2;
   */ _define_property(this, "assetIds", []), /**
   * @generated from field: repeated string required_artifact_types = 3;
   */ _define_property(this, "requiredArtifactTypes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssembleSubmissionPackageRequest, "runtime", proto3);
_define_property(AssembleSubmissionPackageRequest, "typeName", "mono.artifactstudio.v1.AssembleSubmissionPackageRequest");
_define_property(AssembleSubmissionPackageRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "asset_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 3,
            name: "required_artifact_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.artifactstudio.v1.AssembleSubmissionPackageResponse
 */ export class AssembleSubmissionPackageResponse extends Message {
    static fromBinary(bytes, options) {
        return new AssembleSubmissionPackageResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AssembleSubmissionPackageResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AssembleSubmissionPackageResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AssembleSubmissionPackageResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: bool valid = 1;
   */ _define_property(this, "valid", false), /**
   * @generated from field: repeated mono.artifactstudio.v1.SubmissionPackageItem items = 2;
   */ _define_property(this, "items", []), /**
   * @generated from field: repeated string missing_artifact_types = 3;
   */ _define_property(this, "missingArtifactTypes", []), /**
   * @generated from field: repeated string blocked_asset_ids = 4;
   */ _define_property(this, "blockedAssetIds", []), /**
   * @generated from field: repeated string manifest_storage_keys = 5;
   */ _define_property(this, "manifestStorageKeys", []), /**
   * @generated from field: string audit_event_id = 6;
   */ _define_property(this, "auditEventId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(AssembleSubmissionPackageResponse, "runtime", proto3);
_define_property(AssembleSubmissionPackageResponse, "typeName", "mono.artifactstudio.v1.AssembleSubmissionPackageResponse");
_define_property(AssembleSubmissionPackageResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "valid",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 2,
            name: "items",
            kind: "message",
            T: SubmissionPackageItem,
            repeated: true
        },
        {
            no: 3,
            name: "missing_artifact_types",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "blocked_asset_ids",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "manifest_storage_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 6,
            name: "audit_event_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
